import { render, staticRenderFns } from "./DuplicateCaseModal.vue?vue&type=template&id=e156aeb2&scoped=true"
import script from "./DuplicateCaseModal.vue?vue&type=script&lang=js"
export * from "./DuplicateCaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e156aeb2",
  null
  
)

export default component.exports